var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
function isLoaded({ dataset }) {
  return !["src", "srcset"].some((i) => i in dataset);
}
function onIntersection(options) {
  return (entries, observer) => {
    var _a;
    for (const entry of entries) {
      if (!entry.isIntersecting)
        continue;
      const target = entry.target;
      observer.unobserve(target);
      if (isLoaded(target))
        continue;
      onLoad(target, options);
      (_a = options == null ? void 0 : options.onLoaded) == null ? void 0 : _a.call(options, target);
    }
  };
}
var hasNativeLoadingSupport = "loading" in HTMLImageElement.prototype;
var isCrawler = !("onscroll" in window) || /(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent);
function toElementsArray(input, root = document) {
  if (typeof input === "string") {
    return [...root.querySelectorAll(input)];
  }
  if (input instanceof Element) {
    return [input];
  }
  return [...input];
}
function onLoad(element, options) {
  const { useNativeLoading = false } = options;
  const { dataset } = element;
  const { src, srcset, sizes, poster } = dataset;
  if (src) {
    element.src = src;
    delete dataset.src;
  }
  if (element instanceof HTMLImageElement) {
    if (useNativeLoading && hasNativeLoadingSupport && element.loading !== "lazy") {
      element.loading = "lazy";
    }
    if (srcset) {
      element.srcset = srcset;
      delete dataset.srcset;
      if (sizes) {
        element.sizes = sizes === "auto" ? `${element.offsetWidth}px` : sizes;
      }
    }
  }
  if (element instanceof HTMLVideoElement && poster) {
    element.poster = poster;
    delete dataset.poster;
  }
}
class Loadeer {
  constructor(selector = "[data-lazyload]", options = {}) {
    __publicField(this, "observer");
    this.selector = selector;
    this.options = options;
    const {
      root,
      rootMargin,
      threshold,
      useNativeLoading = false
    } = this.options;
    if (!useNativeLoading || !hasNativeLoadingSupport) {
      this.observer = new IntersectionObserver(onIntersection(this.options), {
        root,
        rootMargin,
        threshold
      });
    }
  }
  observe() {
    var _a;
    const { root, onLoaded, useNativeLoading } = this.options;
    const elements = toElementsArray(this.selector, root);
    for (const element of elements) {
      if (isLoaded(element))
        continue;
      if (useNativeLoading && hasNativeLoadingSupport || isCrawler) {
        onLoad(element, this.options);
        onLoaded == null ? void 0 : onLoaded(element);
      } else {
        (_a = this.observer) == null ? void 0 : _a.observe(element);
      }
    }
  }
  triggerLoad(element) {
    var _a, _b;
    if (isLoaded(element))
      return;
    onLoad(element, this.options);
    (_b = (_a = this.options) == null ? void 0 : _a.onLoaded) == null ? void 0 : _b.call(_a, element);
  }
}
let s;
if ((s = document.currentScript) && s.hasAttribute("init")) {
  const instance = new Loadeer();
  instance.observe();
}
export { Loadeer as default };
